export default __webpack_public_path__ + "static/media/payment-method-napas-account.1b726e95.svg";